'use client'

import { useEffect, useState } from 'react'

export const getFormElement = (formId: string) => document.getElementById(formId) as HTMLFormElement | null

/**
 * @description returns the formElement matching the formId. returnvalue is stateful
 * */
export const useFormElement = (formId: string): HTMLFormElement | null => {
    const [formElement, setFormElement] = useState<HTMLFormElement | null>(null)
    useEffect(() => {
        const form = getFormElement(formId)
        if (!form) throw new Error(`Form with id ${formId} not found`)
        setFormElement(form)
    }, [])
    return formElement
}
